export default "__VITE_ASSET__a4638b05__"